
import {
    SET,
    RESET,
    SETNOTIFICATION
} from './types';

import {
    Actions,
} from './actions';

import {
    ErrorHandleItem
} from './ErrorHandledata';

export const errorhandle = (
    context: any,
    initial?: ErrorHandleItem,
) => {
    const initValue = initial || {url:"",error:{},monitor:true,healthCheckUrl:"",notifiy: false};

    return (
        state: ErrorHandleItem,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state || initValue;
        switch (type) {
            case SET:
                updated = payload;
                break;
            case SETNOTIFICATION:
                updated = {
                    ...updated,
                    ...payload
                };
                break;
            case RESET:
                updated = initValue;
                break;
        }
        return updated;
    }
};
